<template>
    <div id="mainArea" class="mainArea">
        <main class="container_pc">
            <h2 class="hdg2-mitsumori">
                お見積り
                <span class="logo logo-header-smaphonenkin logo-header-right"></span>
            </h2>

            <div class="msgtxt" v-show="msgShow"><li>{{ msgTxt }}</li></div>

            <p class="f-sp">お客様の生年月日・性別・保険料を入力してください。</p>

            <div class="frame">
                <span class="mitsumoriLevel">お見積り可能年齢：満18～49歳</span>
            </div>

            <div class="frame2">
                <div class="form">
                    <p class="f-sp3 f-sp4">生年月日</p>
                    <select id="year" class="input-mitsumori" @change="changeValue" v-model="selectedYear">
                    <option v-for="yearOp in yearSelect" :value="yearOp.value" :key="yearOp.value">{{yearOp.text}}</option>
                    </select>
                    <span class="nenFixWord"><span class="triangle"></span></span>
                    <span class="f-sp2">年</span>
                    <input id="month" type="text" class="input-mitsumori2" v-model="selectedMonth" readonly v-b-modal.modal-month/>
                    <span class="f-sp2 f-sp2_right">月</span>
                    <input id="day" type="text" class="input-mitsumori2" v-model="selectedDay" readonly v-b-modal.modal-day/>
                    <span class="f-sp2">日</span>

                    <p class="f-sp3">性別</p>
                    <div class="m-seibetsu">
                        <div class="input-wrap">
                            <div id="male" class="mitsumoriRadio">
                                <input id="seibetsu_1" type="radio" name="seibetsu" value="1" v-model="selectedSex" @change="changeValue">
                                <label class="input-radio" for="seibetsu_1">
                                    <span id="seibetsuRadio" class="mitsumoriRadio_checked">男性</span>
                                </label>
                            </div>
                            <div id="female" class="mitsumoriRadio mitsumoriRadio2">
                                <input id="seibetsu_2" type="radio" name="seibetsu" value="2" v-model="selectedSex" @change="changeValue">
                                <label class="input-radio" for="seibetsu_2">
                                    <span id="seibetsuRadio" class="mitsumoriRadio_checked">女性</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <p class="f-sp3">月払保険料
                        <img class="helpicon_shosai" src="../image/Question.png" v-b-modal.modal-value>
                    </p>
                    <select id="stp" class="input-p-mitsumori" v-model="selectedStp" @change="changeValue">
                        <option value="">---</option>
                        <option value="1">3,000円</option>
                        <option value="2">5,000円</option>
                        <option value="3">10,000円</option>
                        <option value="4">20,000円</option>
                        <option value="5">30,000円</option>
                    </select>
                    <span class="nenFixWord"><span class="triangle"></span></span>

                    <div class="center">
                        <button type="button" class="btn-next-new" @click="quoteRequest" :disabled="isButtonEnabled">
                            <span>見積りを開始する</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>

        <div class="container_phone footer_align">
            <div class="center">
                <span class="span_font1">日本生命お客様サポートオフィス<br>
                    <a class="a_phone" href="tel:0120-996-832">0120-996-832</a>
                </span>

                <span class="span_font2">（通話料無料）<br><span class="margin_right">月～金曜日</span>9:00～18:00<br>（祝日、12/31～1/3を除く）<br></span>

                <div class="bobun_no"><span>（登）日本26-516,26/6/1,ネットワーク業務部</span></div>

                <span class="span_bottom">Copyright (C) 2026 日本生命保険相互会社</span>
            </div>
        </div>

        <!-- 月額保険料のモーダル画面 -->
        <b-modal id="modal-value" centered scrollable>
            <template #modal-header>
                <img class="close_modal_button close_modal_button2" @click="closeModal()">
                <div>
                    <h2 class="hdg2-mitsumori5">月払保険料</h2>
                </div>
            </template>
            <span class="modal_font">保険料の払込回数は月払のみになります。</span>

            <template #modal-footer>
                <div class="center">
                    <button type="button" class="btn-close" @click="closeModal()">
                        <span>閉じる</span>
                    </button>
                </div>
            </template>
        </b-modal>

        <!-- 月のモーダル画面 -->
        <b-modal id="modal-month" size="lg" centered scrollable>
            <template #modal-header>
                <img class="close_modal_button" @click="closeMonth()">
                <div>
                    <h2 class="hdg2-mitsumori6 center">月を選択</h2>
                </div>
            </template>
            <ul class="grid-tsuki number-button-center mx-auto">
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki1" name="select_tsuki" type="radio" value="1" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki1" id="tsukiLabel1" class="btn_number3">
                        <span id="tsukiSpan1">1</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki2" name="select_tsuki" type="radio" value="2" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki2" id="tsukiLabel2" class="btn_number3">
                        <span id="tsukiSpan2">2</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki3" name="select_tsuki" type="radio" value="3" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki3" id="tsukiLabel3" class="btn_number3">
                        <span id="tsukiSpan3">3</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki4" name="select_tsuki" type="radio" value="4" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki4" id="tsukiLabel4" class="btn_number3">
                        <span id="tsukiSpan4">4</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki5" name="select_tsuki" type="radio" value="5" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki5" id="tsukiLabel5" class="btn_number3">
                        <span id="tsukiSpan5">5</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki6" name="select_tsuki" type="radio" value="6" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki6" id="tsukiLabel6" class="btn_number3">
                        <span id="tsukiSpan6">6</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki7" name="select_tsuki" type="radio" value="7" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki7" id="tsukiLabel7" class="btn_number3">
                        <span id="tsukiSpan7">7</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki8" name="select_tsuki" type="radio" value="8" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki8" id="tsukiLabel8" class="btn_number3">
                        <span id="tsukiSpan8">8</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki9" name="select_tsuki" type="radio" value="9" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki9" id="tsukiLabel9" class="btn_number3">
                        <span id="tsukiSpan9">9</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki10" name="select_tsuki" type="radio" value="10" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki10" id="tsukiLabel10" class="btn_number3">
                        <span id="tsukiSpan10">10</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki11" name="select_tsuki" type="radio" value="11" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki11" id="tsukiLabel11" class="btn_number3">
                        <span id="tsukiSpan11">11</span>
                    </label>
                </li>
                <li class="w-tsuki h-tsuki p-tsuki number-button">
                    <input id="check_tsuki12" name="select_tsuki" type="radio" value="12" class="hidden" v-model="selectedMonth" @click="closeMonth" v-b-modal.modal-day/>
                    <label for="check_tsuki12" id="tsukiLabel12" class="btn_number3">
                        <span id="tsukiSpan12">12</span>
                    </label>
                </li>
            </ul>
            <template #modal-footer>
                <div>
                    <button type="button" class="btn-close" @click="closeMonth()">
                        <span>閉じる</span>
                    </button>
                </div>
            </template>
        </b-modal>

        <!-- 日のモーダル画面 -->
        <b-modal id="modal-day" size="lg" centered scrollable>
            <template #modal-header>
                <img class="close_modal_button" @click="closeDay()">
                <div>
                    <h2 class="hdg2-mitsumori6 center">日を選択</h2>
                </div>
            </template>
            <ul class="grid-hi number-button-center mx-auto mx-auto2">
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi1" name="select_hi" type="radio" value="1" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi1" id="hiLabel1" class="btn_number4">
                        <span id="hiSpan1">1</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi2" name="select_hi" type="radio" value="2" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi2" id="hiLabel2" class="btn_number4">
                        <span id="hiSpan2">2</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi3" name="select_hi" type="radio" value="3" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi3" id="hiLabel3" class="btn_number4">
                        <span id="hiSpan3">3</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi4" name="select_hi" type="radio" value="4" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi4" id="hiLabel4" class="btn_number4">
                        <span id="hiSpan4">4</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi5" name="select_hi" type="radio" value="5" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi5" id="hiLabel5" class="btn_number4">
                        <span id="hiSpan5">5</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi6" name="select_hi" type="radio" value="6" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi6" id="hiLabel6" class="btn_number4">
                        <span id="hiSpan6">6</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi7" name="select_hi" type="radio" value="7" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi7" id="hiLabel7" class="btn_number4">
                        <span id="hiSpan7">7</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi8" name="select_hi" type="radio" value="8" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi8" id="hiLabel8" class="btn_number4">
                        <span id="hiSpan8">8</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi9" name="select_hi" type="radio" value="9" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi9" id="hiLabel9" class="btn_number4">
                        <span id="hiSpan9">9</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi10" name="select_hi" type="radio" value="10" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi10" id="hiLabel10" class="btn_number4">
                        <span id="hiSpan10">10</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi11" name="select_hi" type="radio" value="11" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi11" id="hiLabel11" class="btn_number4">
                        <span id="hiSpan11">11</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi12" name="select_hi" type="radio" value="12" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi12" id="hiLabel12" class="btn_number4">
                        <span id="hiSpan12">12</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi13" name="select_hi" type="radio" value="13" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi13" id="hiLabel13" class="btn_number4">
                        <span id="hiSpan13">13</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi14" name="select_hi" type="radio" value="14" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi14" id="hiLabel14" class="btn_number4">
                        <span id="hiSpan14">14</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi15" name="select_hi" type="radio" value="15" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi15" id="hiLabel15" class="btn_number4">
                        <span id="hiSpan15">15</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi16" name="select_hi" type="radio" value="16" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi16" id="hiLabel16" class="btn_number4">
                        <span id="hiSpan16">16</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi17" name="select_hi" type="radio" value="17" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi17" id="hiLabel17" class="btn_number4">
                        <span id="hiSpan17">17</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi18" name="select_hi" type="radio" value="18" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi18" id="hiLabel18" class="btn_number4">
                        <span id="hiSpan18">18</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi19" name="select_hi" type="radio" value="19" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi19" id="hiLabel19" class="btn_number4">
                        <span id="hiSpan19">19</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi20" name="select_hi" type="radio" value="20" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi20" id="hiLabel20" class="btn_number4">
                        <span id="hiSpan20">20</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi21" name="select_hi" type="radio" value="21" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi21" id="hiLabel21" class="btn_number4">
                        <span id="hiSpan21">21</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi22" name="select_hi" type="radio" value="22" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi22" id="hiLabel22" class="btn_number4">
                        <span id="hiSpan22">22</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi23" name="select_hi" type="radio" value="23" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi23" id="hiLabel23" class="btn_number4">
                        <span id="hiSpan23">23</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi24" name="select_hi" type="radio" value="24" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi24" id="hiLabel24" class="btn_number4">
                        <span id="hiSpan24">24</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi25" name="select_hi" type="radio" value="25" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi25" id="hiLabel25" class="btn_number4">
                        <span id="hiSpan25">25</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi26" name="select_hi" type="radio" value="26" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi26" id="hiLabel26" class="btn_number4">
                        <span id="hiSpan26">26</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi27" name="select_hi" type="radio" value="27" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi27" id="hiLabel27" class="btn_number4">
                        <span id="hiSpan27">27</span>
                    </label>
                </li>
                <li class="w-hi h-hi p-hi number-button">
                    <input id="check_hi28" name="select_hi" type="radio" value="28" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi28" id="hiLabel28" class="btn_number4">
                        <span id="hiSpan28">28</span>
                    </label>
                </li>
                <li id="hi29" class="w-hi h-hi p-hi number-button" v-show="lastDay >= 29">
                    <input id="check_hi29" name="select_hi" type="radio" value="29" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi29" id="hiLabel29" class="btn_number4">
                        <span id="hiSpan29">29</span>
                    </label>
                </li>
                <li id="hi30" class="w-hi h-hi p-hi number-button" v-show="lastDay >= 30">
                    <input id="check_hi30" name="select_hi" type="radio" value="30" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi30" id="hiLabel30" class="btn_number4">
                        <span id="hiSpan30">30</span>
                    </label>
                </li>
                <li id="hi31" class="w-hi h-hi p-hi number-button" v-show="lastDay >= 31">
                    <input id="check_hi31" name="select_hi" type="radio" value="31" class="hidden" v-model="selectedDay" @click="closeDay">
                    <label for="check_hi31" id="hiLabel31" class="btn_number4">
                        <span id="hiSpan31">31</span>
                    </label>
                </li>
            </ul>
            <template #modal-footer>
                <div>
                    <button type="button" class="btn-close" @click="closeDay()">
                        <span>閉じる</span>
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<style>
    .f-sp {
        font-size: 16px;
        margin-bottom: -18px;
    }

    .f-sp2 {
        font-size: 16px;
        font-weight: bold;
        margin: 0px 20px 0px 10px;
    }

    .f-sp3 {
        font-size: 1.6rem;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 30px;
    }

    .f-sp4 {
        margin-top: 10px;
        margin-bottom: -10px;
    }

    .mitsumoriLevel {
        font-size: 14px;
    }

    .frame {
        padding: 4px 0px 4px 8px;
        border: 1px solid #EEEEEE;
        background-color: #FFFFFF;
        margin-top: 22px;
        margin-bottom: 16px;
        width: 220px;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: none;
    }

    .frame2 {
        background-color: #FFFFFF;
        border: 1px solid #CCCCCC;
        border-radius: 16px;
        margin: 28px 0 25px;
        padding: 40px 130px;
    }

    .input-mitsumori {
        box-sizing: border-box;
        display: inline;
        justify-content: center;
        align-items: center;
        padding: 10px;
        width: 269px;
        height: 56px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        border-radius: 8px;
        flex: none;
        order: 0;
        flex-grow: 0;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        outline: none;
        box-shadow: 0 5px 10px -5px #cccccc;
    }

    .input-mitsumori2 {
        box-sizing: border-box;
        display: inline;
        justify-content: center;
        align-items: center;
        padding: 16px 0px;
        min-width: 110px;
        width: 50px;
        height: 56px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        border-radius: 8px;
        flex: none;
        order: 0;
        flex-grow: 0;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        outline: none;
        margin-top: 20px;
        box-shadow: 0 5px 10px -5px #cccccc;
    }

    /* プルダウン */
    .input-p-mitsumori {
        box-sizing: border-box;
        display: inline;
        justify-content: center;
        align-items: center;
        padding: 16px 0px;
        width: 100%;
        height: 56px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        border-radius: 8px;
        flex: none;
        order: 0;
        flex-grow: 0;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        outline: none;
        box-shadow: 0 5px 10px -5px #cccccc;
    }

    @media screen and (min-width: 753px) {
        .form {
            width: 627px;
            margin: 0 auto;
        }
    }

    @media screen and (max-width: 920px) {
        .frame2 {
            padding: 40px 50px;
        }
    }

    @media screen and (max-width: 752px) {
        .form {
            width: 315px;
            margin: 0 auto;
        }

        .f-sp4 {
            margin-bottom: 10px;
        }
    }

    @media screen and (max-width: 480px) {
        .form {
            width: 302px;
            margin: 0 auto;
        }

        .frame {
            margin: 8px 0px -15px 0px;
            width: 190px;
        }

        .frame2 {
            padding: 20px;
        }

        .f-sp {
            font-size: 1.4rem;
            margin-bottom: -5px;
        }

        .f-sp2 {
            margin: 0px 0px 0px 10px;
        }

        .f-sp2_right {
            margin-right: 23px;
        }

        .mitsumoriLevel {
            font-size: 12px;
        }
    }

    .m-seibetsu {
        display: block;
        justify-content: center;
    }

    .input-wrap {
        padding: 0;
        margin: auto;
    }

    .mitsumoriRadio {
        margin-right: 20px;
        box-sizing: border-box;
        display: inline-block;
        margin-bottom: 0;
        border: 1px solid #DDDDDD;
        box-shadow: 0 5px 10px -5px #cccccc;
        border-radius: 8px;
        width: 145px;
        height: 56px;
        padding-top: 15px;
        font-size: 18px;
    }

    .mitsumoriRadio2 {
        margin-right: 0px;
    }

    .mitsumoriRadio_checked {
        padding-left: 55px;
    }

    @media screen and (max-width: 480px) {
        .mitsumoriRadio {
            width: 141px;
        }
    }

    .input-radio {
        position: relative;
        display: block;
        font-weight: bold;
    }

    .input-radio::before {
        position: absolute;
        top: 50%;
        left: 17px;
        width: 12px;
        height: 12px;
        margin-top: -7px;
        content: "";
        background: #ed1c24;
        border-radius: 50%;
        z-index: 1;
        opacity: 0;
    }

    .input-radio::after {
        position: absolute;
        top: 50%;
        left: 12px;
        width: 22px;
        height: 22px;
        margin: -12px auto 0;
        content: "";
        border: 1px solid #bbb;
        background: #fff;
        border-radius: 50%;
    }

    .mitsumoriRadio input {
        position: relative;
        display: none;
    }

    .mitsumoriRadio input:checked + .input-radio::before {
        opacity: 1;
    }

    .msgtxt {
        white-space: pre-line;
        font-size: 1.4rem;
        padding: 70px 0px 0px 0px;
        color: #CC0000;
        margin-bottom: 20px;
    }

    .msgtxt > li {
        color				:#CC0000;
        padding				:20px 15px 0px 45px;
        margin				:0px;
        list-style          :none;
        position: relative;
    }

    .msgtxt > li::before {
        background-image	:url("../image/CmnInfo.png");
        background-repeat	:no-repeat;
        height				:22px;
        width				:22px;
        position			:absolute;
        left				:12px;
        top					:18px;
        background-size		:contain;
        content: '';
        position:absolute;
    }

    /* ---------------------------フッター文字------------------------------------- */
    .bobun_no {
        text-align: right;
        padding: 8px 15px 0px 0px;
        font-size: 1.4rem;
    }

    /* ---------------------------月日モーダル共通------------------------------------- */
    ul {
        list-style-type: none;
    }

    .modal-footer-content {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* ---Bootstrapのデフォルトスタイルを強制上書き--- */
    .modal-header {
        display: block !important;
        justify-content: center !important;
        border-bottom: none !important;
    }

    #modal-value .modal-body,
    #modal-value2 .modal-body {
        height: 65vh;
        max-height: 620px;
    }

    .modal-footer {
        justify-content: center !important;
        border-top: none !important;
    }

    .number-button-center {
        max-width: 630px;
    }

    .mx-auto {
        margin-top: 60px;
        margin-bottom: 55px;
        margin-left: auto;
        margin-right: auto;
    }

    .mx-auto2 {
        margin-top: 40px;
        margin-bottom: 20px;
    }

    .hidden {
        display: none;
    }

    .hdg2-mitsumori6 {
        border-bottom: 2px solid #ed1c24;
        padding-bottom: 8px;
        width: 100%;
        font-weight: bold;
        font-size: 32px;
        align-items: center;
        color: #333;
        margin-top: 10px;
    }

    .number-button {
        margin: 0 auto;
        font-weight: bold;
    }

    .modal-width {
        width: 50%;
        margin: 0 auto;
    }

    input[name="select_tsuki"]:checked + label,
    input[name="select_hi"]:checked + label {
        background-color: #ED1C24;
    }

    input[name="select_tsuki"]:checked + label > span,
    input[name="select_hi"]:checked + label > span {
        color: #FFFFFF;
    }

    @media screen and (max-width: 480px) {
        .hdg2-mitsumori6 {
            font-size: 24px;
        }
    }

    /* ---------------------------月モーダル------------------------------------- */
    .grid-tsuki {
        display: grid;
        grid-template-columns: repeat(auto-fit, 92px);
        justify-content: center;
        grid-gap: 5px;
    }

    .w-tsuki {
        width: 92px;
    }

    .h-tsuki {
        height: 92px;
    }

    .p-tsuki {
        padding: 10px;
    }

    .btn_number3 {
        font-size: 24px;
        line-height: 2.25rem;
        border: 1px solid #ccc;
        border-radius: 50%;
        background-color: #FAF7F0;
        justify-content: center;
        align-items: center;
        height: 100%;
        display: flex;
        position: relative;
    }

    @media screen and (max-width: 480px) {
        .grid-tsuki {
            grid-template-columns: auto auto auto;
        }
    }

    /* ---------------------------日モーダル------------------------------------- */
    .grid-hi {
        display: grid;
        grid-template-columns: repeat(auto-fit, 55px);
        justify-content: center;
        grid-gap: 5px;
    }

    .w-hi {
        width: 60px;
    }

    .h-hi {
        height: 60px;
    }

    .p-hi {
        padding: 7.5px;
    }

    .btn_number4 {
        font-size: 18px;
        line-height: 2.25rem;
        border: 1px solid #ccc;
        border-radius: 50%;
        background-color: #FAF7F0;
        justify-content: center;
        align-items: center;
        height: 100%;
        display: flex;
        position: relative;
    }

    @media screen and (max-width: 480px) {
        .grid-hi {
            grid-template-columns: 52px 52px 52px 52px 60px;
        }
    }
</style>

<script>
import ageUtil from "@/script/age.js";
import check from "@/script/check.js";
export default {
    name: "seinengappiNyuryoku",
    props: {
        age: {type: Number, default: 0},
        year: {type: String, default: ""},
        month: {type: String, default: "---"},
        day: {type: String, default: "---"},
        sex: {type: String, default: ""},
        stp: {type: String, default: ""},
        msgTxt: {type: String},
        msgShow: {type: Boolean, required: true},
        show: {type: String}
    },
    data: function() {
        return {
            calcAge: this.age,
            selectedYear: this.year,
            selectedMonth: this.month,
            selectedDay: this.day,
            selectedSex: this.sex,
            selectedStp: this.stp,
            yearSelect: [],
            monthSelect: [],
            daySelect: [],
            sexSelect: [{value: "1", text: "男性2"},  {value: "2", text: "女性"}],
            lastDay: 31,
        }
    },
    created: function() {
        //-----年プルダウンに18年前～50年前の値をセット------
        const baseDate = ageUtil.getKeisankijunbi();
        const minYear = baseDate.getFullYear() - 50;
        const nowDate = ageUtil.getJstNowDate();
        const maxYear = nowDate.getFullYear() - 18;
        let age = 18;
        for (var i = maxYear; i >= minYear; i--) {
            //値を生成してプルダウンにセット
            const seireki = i.toString();
            var yeartxt = seireki + "（" + this.wareki(i) + "）";
            this.yearSelect.push({value: seireki, text: yeartxt});

            //29歳と30歳の間にデフォルト値をセット
            age++;
            if (age == 30) {
                this.yearSelect.push({value: "", text: "---"});
            }
        }

    },
    mounted: function() {
        // 青枠セット（項目：年）
        var objYear = document.getElementById("year");
        if (this.selectedYear != "") {
            objYear.style.border = "1px solid  #11aaf6";
        } else {
            objYear.style.border = "1px solid #DDDDDD";
        }
        // 青枠セット（項目：月）
        var objMonth = document.getElementById("month");
        if (this.selectedMonth != "" && this.selectedMonth != "---") {
            objMonth.style.border = "1px solid  #11aaf6";
        } else {
            objMonth.style.border = "1px solid #DDDDDD";
        }
        // 青枠セット（項目：日）
        var objDay = document.getElementById("day");
        if (this.selectedDay != "" && this.selectedDay != "---") {
            objDay.style.border = "1px solid  #11aaf6";
        } else {
            objDay.style.border = "1px solid #DDDDDD";
        }
        // 青枠セット（項目：性別）
        var objSex = document.getElementById("male");
        var objSex2 = document.getElementById("female");
        if (this.sex == "1") {
            objSex.style.border = "1px solid  #11aaf6";
            objSex2.style.border = "1px solid #DDDDDD";
        } else if(this.sex == "2") {
            objSex.style.border = "1px solid #DDDDDD";
            objSex2.style.border = "1px solid  #11aaf6";
        }
        // 青枠セット（項目：月払保険料）
        var objHokenryo = document.getElementById("stp");
        if (this.selectedStp != "") {
            objHokenryo.style.border = "1px solid  #11aaf6";
        } else {
            objHokenryo.style.border = "1px solid #DDDDDD";
        }
    },
    computed: {
        isButtonEnabled() {
            return this.selectedYear == "" || this.selectedMonth == "" || this.selectedMonth == "---" || this.selectedDay == "" || this.selectedDay == "---" || this.selectedSex == "" || this.selectedStp == ""
        },
    },
    watch: {
        selectedYear() {
            this.hiddenDayRadio();

            // 青枠セット（項目：年）
            var obj = document.getElementById("year");
            if (this.selectedYear != "") {
                obj.style.border = "1px solid  #11aaf6";
            } else {
                obj.style.border = "1px solid #DDDDDD";
            }

            // 存在しない日付の場合クリア
            if (this.selectedYear != "" && this.selectedMonth != "" && this.selectedMonth != "---" && this.selectedDay != "" && this.selectedDay != "---") {
                const year = this.selectedYear;
                const month = this.selectedMonth;
                const day = this.selectedDay;
                const ymd = year + month.padStart(2, "0") + day.padStart(2, "0");
                if (!check.chkDate(ymd)) {
                    this.selectedDay = "---";
                }
            }
            // 存在しない日付の場合クリア(年なし)
            if ( this.selectedYear == "" ) {
                if ( this.selectedMonth == "2" ) {
                    if ( this.selectedDay == "29" || this.selectedDay == "30" || this.selectedDay == "31" ) {
                        this.selectedDay = "---";
                    }
                } else if ( this.selectedMonth == "4" || this.selectedMonth == "6" || this.selectedMonth == "9" || this.selectedMonth == "11" ) {
                    if ( this.selectedDay == "31" ) {
                        this.selectedDay = "---";
                    }
                }
            }
            this.$emit("updCommon", this.selectedYear, this.selectedMonth, this.selectedDay, this.selectedSex, this.selectedStp );
        },
        selectedMonth() {
            this.hiddenDayRadio()

            // 青枠セット（項目：月）
            var obj = document.getElementById("month");
            if (this.selectedMonth != "") {
                obj.style.border = "1px solid  #11aaf6";
            } else {
                obj.style.border = "1px solid #DDDDDD";
            }

            // 存在しない日付の場合クリア
            if (this.selectedYear != "" && this.selectedMonth != "" && this.selectedMonth != "---" && this.selectedDay != "" && this.selectedDay != "---") {
                const year = this.selectedYear;
                const month = this.selectedMonth;
                const day = this.selectedDay;
                const ymd = year + month.padStart(2, "0") + day.padStart(2, "0");
                if (!check.chkDate(ymd)) {
                    this.selectedDay = "---";
                }
            }
            // 存在しない日付の場合クリア(年なし)
            if ( this.selectedYear == "" ) {
                if ( this.selectedMonth == "2" ) {
                    if ( this.selectedDay == "29" || this.selectedDay == "30" || this.selectedDay == "31" ) {
                        this.selectedDay = "---";
                    }
                } else if ( this.selectedMonth == "4" || this.selectedMonth == "6" || this.selectedMonth == "9" || this.selectedMonth == "11" ) {
                    if ( this.selectedDay == "31" ) {
                        this.selectedDay = "---";
                    }
                }
            }
            this.$emit("updCommon", this.selectedYear, this.selectedMonth, this.selectedDay, this.selectedSex, this.selectedStp )
        },
        selectedDay() {
            // 青枠セット（項目：日）
            var obj = document.getElementById("day");
            if (this.selectedDay != "" && this.selectedDay != "---") {
                obj.style.border = "1px solid  #11aaf6";
            } else {
                obj.style.border = "1px solid #DDDDDD";
            }
            this.$emit("updCommon", this.selectedYear, this.selectedMonth, this.selectedDay, this.selectedSex, this.selectedStp )
        },
        sex(newVal) {
            this.sex = newVal

            // 青枠セット（項目：性別）
            var obj = document.getElementById("male");
            var obj2 = document.getElementById("female");
            if (this.sex == "1") {
                obj.style.border = "1px solid  #11aaf6";
                obj2.style.border = "1px solid #DDDDDD";
            } else if(this.sex == "2") {
                obj.style.border = "1px solid #DDDDDD";
                obj2.style.border = "1px solid  #11aaf6";
            }
        },
        stp(newVal) {
            this.selectedStp = newVal

            // 青枠セット（項目：月払保険料）
            var obj = document.getElementById("stp");
            if (this.selectedStp != "") {
                obj.style.border = "1px solid  #11aaf6";
            } else {
                obj.style.border = "1px solid #DDDDDD";
            }
        },
        show() {
            this.yearSelect = [];
            //-----年プルダウンに18年前～50年前の値をセット------
            const baseDate = ageUtil.getKeisankijunbi();
            const minYear = baseDate.getFullYear() - 50;
            const nowDate = ageUtil.getJstNowDate();
            const maxYear = nowDate.getFullYear() - 18;
            let age = 18;
            for (var i = maxYear; i >= minYear; i--) {
                //値を生成してプルダウンにセット
                const seireki = i.toString();
                var yeartxt = seireki + "（" + this.wareki(i) + "）";
                this.yearSelect.push({value: seireki, text: yeartxt});

                //29歳と30歳の間にデフォルト値をセット
                age++;
                if (age == 30) {
                    this.yearSelect.push({value: "", text: "---"});
                }
            }
            const bdYear = parseInt(this.selectedYear);
            if (bdYear < minYear) {
                this.selectedYear = "";
                this.$emit("clearYear");
            }
        }
    },
    methods: {
        //和暦変換メソッド
        wareki(year) {
            var eras = [
                {year: 2018, name: "令和"},
                {year: 1988, name: "平成"},
                {year: 1925, name: "昭和"}
            ]

            for(var i in eras) {

                var era = eras[i];
                var baseYear = era.year;
                var eraName = era.name;

                if(year < 1926){
                    return "---";
                }else if(year == 1989) {
                    return "昭和64・平成1";
                }else if(year == 2019){
                    return "平成31・令和1";
                }else if(year > baseYear) {
                    var eraYear = year - baseYear;
                    return eraName + eraYear;
                }
            }
            return null;
        },
        //画面項目の値変更
        changeValue() {
            this.hiddenDayRadio();
            this.$emit("updCommon", this.selectedYear, this.selectedMonth, this.selectedDay, this.selectedSex, this.selectedStp );
        },
        //月モーダルを閉じる
        closeMonth() {
            this.hiddenDayRadio();
            this.$bvModal.hide("modal-month");
        },
        //日モーダルを閉じる
        closeDay() {
            this.$bvModal.hide("modal-day");
        },
        //月払保険料モーダルを閉じる
        closeModal() {
            this.$bvModal.hide("modal-value");
        },
        quoteRequest() {
            this.$emit("quoteRequest");
        },
        hiddenDayRadio() {
            if ( this.selectedYear != "" && this.selectedMonth != "" && this.selectedMonth != "---" ) {
                const year = parseInt(this.selectedYear);
                const month = parseInt(this.selectedMonth);
                this.lastDay = new Date(year, month, 0).getDate();
            } else if ( this.selectedYear == "" ) {
                if ( this.selectedMonth == "2") {
                    this.lastDay = 28;
                } else if ( this.selectedMonth == "4" || this.selectedMonth == "6" || this.selectedMonth == "9" || this.selectedMonth == "11" ) {
                    this.lastDay = 30;
                } else {
                    this.lastDay = 31;
                }
            } else {
                this.lastDay = 31;
            }
        },
    }
}
</script>